import { getWebsiteIdFromPath } from './util/websiteIdExtractor';

const searchField = document.querySelector('#global-search-field');

if (searchField !== null) {
    const searchResultBody = document.querySelector('[data-search-modal-body]');
    const startSearchBody = document.querySelector('[data-search-modal-empty]');
    const noResultsSearchBody = document.querySelector('[data-search-modal-not-found]');

    const locale = document.documentElement.lang;

    searchField.addEventListener('input', () => {
        if (searchField.value.length === 0) {
            searchResultBody.innerHTML = startSearchBody.innerHTML;
            return;
        }

        if (searchField.value.length <= 2) {
            return;
        }

        fetch(`/${getWebsiteIdFromPath()}/search?q=${encodeURIComponent(searchField.value)}`)
            .then((response) => {
                return response.json();
            })
            .then((json) => {
                if (json.length === 0) {
                    searchResultBody.innerHTML = noResultsSearchBody.innerHTML;
                    return;
                }

                const resultList = document.createElement('ul');
                resultList.classList.add('h-96', 'scroll-pb-2', 'scroll-pt-11', 'overflow-y-auto', 'pb-2');
                for (const resultSet of json) {
                    const subResultList = document.createElement('li');
                    // build header
                    const subResultListHeader = document.createElement('h2');
                    subResultListHeader.classList.add(
                        'bg-gray-100',
                        'dark:bg-gray-700',
                        'px-4',
                        'py-2.5',
                        'text-xs',
                        'font-semibold',
                        'text-gray-900',
                        'dark:text-white',
                        'select-none',
                    );
                    subResultListHeader.innerText = resultSet['title'];
                    subResultList.append(subResultListHeader);

                    // build body
                    const subResultListBody = document.createElement('div');
                    subResultListBody.classList.add('text-sm');
                    for (const item of resultSet['items']) {
                        const subResultListItem = document.createElement('a');
                        subResultListItem.classList.add(
                            'flex',
                            'w-full',
                            'justify-between',
                            'select-none',
                            'px-4',
                            'py-2',
                            'hover:bg-accent-200',
                            'dark:hover:bg-accent-700',
                            'dark:text-white',
                            'hover:font-bold',
                        );
                        subResultListItem.href = item['url'];
                        const label = document.createElement('span');
                        label.innerText = item['title'];
                        const date = document.createElement('time');
                        date.dateTime = item['date'];
                        date.innerText = new Intl.DateTimeFormat(locale).format(new Date(date.dateTime));
                        date.classList.add('px-2.5', 'py-0.5', 'bg-secondary-600', 'text-white', 'rounded-lg', 'text-sm');
                        subResultListItem.append(label, date);
                        subResultListBody.append(subResultListItem);
                    }
                    subResultList.append(subResultListBody);
                    resultList.append(subResultList);
                }

                searchResultBody.innerText = '';
                searchResultBody.append(resultList);
            });
    });

    const searchModal = document.querySelector('dialog[data-search-modal]');

    if (searchModal !== null) {
        window.addEventListener('keydown', (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
                e.preventDefault();

                searchModal.showModal();
            }
        });
    }
}
